var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 6,
    fill: "#0071A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5352 13L21.9922 22.9941H19.5791L18.2256 17.7441C18.1982 17.6439 18.1618 17.4912 18.1162 17.2861C18.0706 17.0811 18.0228 16.8577 17.9727 16.6162C17.9225 16.3701 17.877 16.14 17.8359 15.9258C17.7995 15.707 17.7744 15.5339 17.7607 15.4062C17.7471 15.5339 17.7197 15.7048 17.6787 15.9189C17.6423 16.1331 17.599 16.361 17.5488 16.6025C17.5033 16.8441 17.4577 17.0697 17.4121 17.2793C17.3665 17.4889 17.3301 17.6484 17.3027 17.7578L15.9561 22.9941H13.5498L11 13H13.085L14.3633 18.4551C14.3997 18.6191 14.4408 18.8151 14.4863 19.043C14.5365 19.2708 14.5843 19.5101 14.6299 19.7607C14.68 20.0068 14.7233 20.2461 14.7598 20.4785C14.8008 20.7064 14.8304 20.9046 14.8486 21.0732C14.8714 20.9001 14.901 20.6995 14.9375 20.4717C14.974 20.2393 15.0127 20.0046 15.0537 19.7676C15.0993 19.526 15.1449 19.3027 15.1904 19.0977C15.236 18.8926 15.277 18.7262 15.3135 18.5986L16.7695 13H18.7725L20.2285 18.5986C20.2604 18.7217 20.2969 18.888 20.3379 19.0977C20.3835 19.3027 20.429 19.526 20.4746 19.7676C20.5202 20.0091 20.5612 20.2461 20.5977 20.4785C20.6387 20.7064 20.6683 20.9046 20.6865 21.0732C20.7184 20.8454 20.7617 20.5697 20.8164 20.2461C20.8757 19.918 20.9372 19.5921 21.001 19.2686C21.0693 18.945 21.1286 18.6738 21.1787 18.4551L22.4502 13H24.5352Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocFile);
export default __webpack_public_path__ + "static/media/doc-file.800d0997752318669dd8c73e5f88fd8f.svg";
export { ForwardRef as ReactComponent };